document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('ffp__variant')) return;
  var card = e.target.closest('.ffp__card');
  if (!card) return;
  var input = card.querySelector('input[name="id"]');
  if (input) input.value = e.target.value;
});

function findVariantId(variants, selected) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (
      (selected[0] == null || v.option1 === selected[0]) &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    ) return v.id;
  }
  return null;
}

function isValueAvailable(variants, index, draft) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var ok =
      (draft[0] == null || v.option1 === draft[0]) &&
      (draft[1] == null || v.option2 === draft[1]) &&
      (draft[2] == null || v.option3 === draft[2]);
    if (ok && v.available) return true;
  }
  return false;
}

document.addEventListener('click', function (e) {
  var pill = e.target.closest('.ffp__pill');
  if (!pill) return;

  var optionEl = pill.closest('.ffp__option');
  var card = pill.closest('.ffp__card');
  var optionsRoot = card.querySelector('.ffp__options');
  if (!optionsRoot) return;

  var variants = [];
  try { variants = JSON.parse(optionsRoot.dataset.variants); } catch(e){}

  
  var idx = parseInt(optionEl.dataset.optionIndex, 10);
  optionEl.querySelectorAll('.ffp__pill').forEach(function(btn){ btn.classList.remove('is-active'); });
  pill.classList.add('is-active');
  var currentLabel = optionEl.querySelector('.ffp__current');
  if (currentLabel) currentLabel.textContent = pill.dataset.value;

 
  var selected = [null, null, null];
  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    var active = group.querySelector('.ffp__pill.is-active');
    if (active) selected[gi] = active.dataset.value;
  });

  
  var id = findVariantId(variants, selected);
  var idInput = card.querySelector('input[name="id"]');
  if (id && idInput) idInput.value = id;


  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    group.querySelectorAll('.ffp__pill').forEach(function(btn){
      var draft = selected.slice();
      draft[gi] = btn.dataset.value;
      var available = isValueAvailable(variants, gi, draft);
      btn.disabled = !available;
    });
  });
});


function ffpFormatMoney(cents) {
  try {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      // Use Shopify's native formatter (respects currency and locale)
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
  } catch (e) {}


  var n = (parseInt(cents, 10) / 100).toFixed(2);
  var currencySymbol = (window.Shopify && Shopify.currency && Shopify.currency.active)
    ? Shopify.currency.active
    : '{{ shop.currency }}'; 
  return n + ' ' + currencySymbol;
}


function ffpGetVariants(card) {
  var root = card.querySelector('.ffp__options');
  if (!root || !root.dataset.variants) return [];
  try { return JSON.parse(root.dataset.variants); } catch(e) { return []; }
}

function ffpGetSelectedArray(card) {
  var selected = [null, null, null];
  card.querySelectorAll('.ffp__option').forEach(function(group){
    var gi = parseInt(group.dataset.optionIndex, 10);
    var active = group.querySelector('.ffp__pill.is-active');
    if (active) selected[gi] = active.dataset.value;
  });
  return selected;
}

function ffpFindVariantBySelections(variants, selected) {
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    if (
      (selected[0] == null || v.option1 === selected[0]) &&
      (selected[1] == null || v.option2 === selected[1]) &&
      (selected[2] == null || v.option3 === selected[2])
    ) return v;
  }
  return null;
}

function ffpUpdatePriceForCard(card) {
  var variants = ffpGetVariants(card);
  if (!variants.length) return;

  var idInput = card.querySelector('input[name="id"]');
  var variant = null;
  if (idInput && idInput.value) {
    var vid = parseInt(idInput.value, 10);
    variant = variants.find(function(v){ return v.id === vid; }) || null;
  }


  if (!variant) {
    var selected = ffpGetSelectedArray(card);
    variant = ffpFindVariantBySelections(variants, selected);
  }
  if (!variant) return;

  var priceWrap = card.querySelector('.ffp__price');
  if (!priceWrap) return;

  var html;
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    html =
      '<span class="price-item price-item--sale">' + ffpFormatMoney(variant.price) + '</span>' +
      '<span class="price-item price-item--compare">' + ffpFormatMoney(variant.compare_at_price) + '</span>';
  } else {
    html = '<span class="price-item">' + ffpFormatMoney(variant.price) + '</span>';
  }
  priceWrap.innerHTML = html;
}


document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('ffp__variant')) return;
  var card = e.target.closest('.ffp__card');
  if (!card) return;
  ffpUpdatePriceForCard(card);
});


document.addEventListener('click', function (e) {
  var pill = e.target.closest('.ffp__pill');
  if (!pill) return;
  var card = pill.closest('.ffp__card');
  if (!card) return;

  setTimeout(function(){ ffpUpdatePriceForCard(card); }, 0);
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ffp__card').forEach(ffpUpdatePriceForCard);
});




